<template>
  <MUIDialog
    :acceptItem="acceptItem"
    :dismissItem="dismissItem"
    :displayType="displayType"
    :title="title"
    ref="dialog">
    <div class="form-group field-input">
      <div class="field-wrap">
        <input
          data-vv-delay='1000'
          name='name'
          ref='nameInput'
          type='text'
          placeholder='Enter a collection name'
          v-model.trim='name'>
      </div>
      <span v-if="error.name" class="help is-danger">{{error.name[errors[0]]}}</span>
    </div>
  </MUIDialog>
</template>

<script>
import { APP } from '../config'
import {
  errorMessages
} from '@/utils'

import {
  MUIDialog
} from '../components'

export default {
  components: {
    MUIDialog
  },
  data () {
    return {
      acceptItem: {
        name: 'Save',
        fn: () => { this.acceptHandler() }
      },
      dismissItem: {
        name: 'Cancel'
      },
      displayType: APP,
      errors: [],
      name: null,
      title: 'New Collection'
    }
  },
  computed: {
    error () {
      return this.errors.length > 0 && errorMessages().collection
    }
  },
  methods: {
    acceptHandler () {
      if (!this.name) this.errors.push('required')
      if (this.errors.length > 0) return

      this.$store.dispatch('createCollection', {
        uid: this.$store.state.User.uid,
        name: this.name
      }).then(collectionKey => {
        let path = this.$urlHelpers.collectionPath(collectionKey)
        this.$router.currentRoute.path !== path && this.$router.push(path)
        this.$track('collection.create', {
          context: 'collection',
          ability: 'create',
          collectionId: collectionKey,
          collectionName: this.name
        })
        this.resetForm()
        this.$refs.dialog.close()
      }).catch(error => {
        console.log(error)
        this.errors.push('unique')
      })
    },
    resetForm () {
      this.name = null
      this.errors = []
    }
  },
  mounted () {
    this.$refs.nameInput.focus()
  },
  watch: {
    name () {
      if (!this.name) return
      this.errors.pop('required')

      Object.values(this.$store.state.Collection.collections).filter(collection => {
        return collection.name.toUpperCase() === this.name.toUpperCase()
      }).length > 0 ? this.errors.push('unique') : this.errors.pop('unique')
      this.errors = [...new Set(this.errors)]
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/CollectionNewDialog.vue